import { connect } from "./Axios";
import { Fetch } from "./APIUrl";



// Property login All Api

export const PropertyLoginApi = async (Username, Password) => {
  try {

    let data = new FormData();
    data.append('Username', Username);
    data.append('Password', Password);


    const response = await connect.post(Fetch.Proporetylogin, data);
    console.log("proprety login", response);
    return response.data;
  }
  catch (error) {
    console.log("error fetching Propoerty login", error);
  }
};

// user logout
export const PropertyLogoutuser = async () => {
  try {
    const Username = localStorage.getItem("PropertyUsername");
    const Password = localStorage.getItem("PropertyPassword");
    const token = localStorage.getItem("PropertyAuthToken");

    if (!Username || !Password || !token) {
      console.log("Missing logout credentials");
      return null;
    }

    let data = new FormData();
    data.append("Username", Username);
    data.append("Password", Password);
    data.append("AuthToken", token);

    const response = await connect.post(Fetch.LogOutUser, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.log("Error logging out user", error);
    return null;
  }
};

// DAshboadr Room Inventory
export const DashboRoomInventory = async (startDate, endDate) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    console.log("sdate", startDate)
    console.log("edate", endDate)

    const finalURL = `${Fetch.DashboardRoomInventory}?StartDate=${startDate}&EndDate=${endDate}`;

    console.log("FINAL API URL:", finalURL);

    const response = await connect.get(finalURL, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Dashboard Room inventory", error);
  }
}

// get Basic Property details
export const getBasicPropertydetails = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BasicPropoertydetails, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Property details", error);
  }
}

// Basic Proprety Save
export const BasicPropoertysaveApi = async (propertyData, logoFile) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const formData = new FormData();
    formData.append(
      "property",
      JSON.stringify({
        ...propertyData,
        IsPMS: propertyData.IsPMS === "" ? null : Number(propertyData.IsPMS),
      })
    );
    if (logoFile) {
      formData.append("PropertyLogoFile", logoFile);
    }

    const response = await connect.post(Fetch.BasicPropertydetailSave, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    return response.data;
  }
  catch (error) {
    console.log("error fetch save basic property", error);
  }
};


// basic get and save contact detail
export const getContactdetal = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BasicContactdetail, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get contect detail", error);
  }
}

export const SaveConteactdetail = async (addressString) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.BasicContactdetailSave, addressString, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error save data contact", error);
  }
}

// basic get and save Property Location
export const getPropertylocation = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");


    const response = await connect.get(Fetch.BasicPropertyLocation, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get property location", error);
  }
}


export const SavePropertyloaction = async (address) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.BasicPropertylocationSave, address, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save location", error);
  }
}

// basic get bank details
export const getBankdetal = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BasicBankdetail, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get bank detail", error);
  }
}

export const SaveBankdetails = async (data) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.BasicBankdetailSave, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save bank details", error);
  }
}

// basic get and save Gst details
export const getGstdetail = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BasicGstdetail, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get Gst detail", error);
  }
}

export const SaveGstdetail = async (gstData) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");
    const response = await connect.post(Fetch.BasicGstdetailSave, gstData, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error save Gst details", error);
  }
}

// amenites get and save data
export const getAmenities = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.AmenitesDetails, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get amenities", error);
  }
}

export const AmenitiesSave = async (data, AmenitiesID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const url = `${Fetch.SaveAmenitiesdetail}?AmenitiesID=${AmenitiesID}`;

    const response = await connect.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Amenities", error);
  }
}



// room detall get , save
export const roomlistdetail = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.Roomdetail, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log("api data form back end", response)
    return response.data;
  }
  catch (error) {
    console.log("error get room list", error);
  }
}

export const SaveRoomdetail = async (roomData, imageFile) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const formData = new FormData();
    formData.append("Rooms", JSON.stringify(roomData));
    if (imageFile) {
      formData.append("PropertyRoomPhoto", imageFile);
    }

    const response = await connect.post(Fetch.Saveroomdetail, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;

  }
  catch (error) {
    console.log("error save room details", error);
  }
}

export const MealPlansave = async (data) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.SaveMealplan, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Meal plan", error);
  }
}

// booking get and save api
// Service.js
export const getProportyBookings = async (checkIn, checkOut, rateTypeCode, rateCodeID, totalRoom) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.NewBooking, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        CheckIn: checkIn,
        CheckOut: checkOut,
        RateTypeCode: rateTypeCode,
        RateCodeID: rateCodeID,
        TotalRoom: totalRoom,
      }
    });

    return response.data;
  } catch (error) {
    console.log("error getting Bookings", error);
  }
};

export const getRoomRateSelect = async (rateCodeID, mealPlanID, roomTypeID, rateType, rateTypeID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const url = `${Fetch.RoomRateSelect}?rateCodeID=${rateCodeID}&mealPlanID=${mealPlanID}&roomTypeID=${roomTypeID}&rateType=${rateType}&rateTypeID=${rateTypeID}`;

    console.log("rateCodeID:", rateCodeID);
    console.log("mealPlanID:", mealPlanID);
    console.log("roomTypeID:", roomTypeID);
    console.log("rateType:", rateType);
    console.log("rateTypeID:", rateTypeID);
    console.log("URL:", url);

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // console.log("API Response:", response.data);

    return response.data;
  }
  catch (error) {
    console.log("error get Room rate select", error);
  }
}



export const SavePreBookingRoomAdd = async (formData) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.PrebookingroomAdd, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      }
    });
    return response.data;
  }
  catch (error) {
    if (!error.response) {
      return { Message: "Network error. Please check your internet connection." };
    }
    return error.response?.data || { Message: "Something went wrong" };
  }
}


export const GetPreBookingRoomdetail = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");
    const preBookingToken = localStorage.getItem("PreBookingToken");

    console.log("PropertyAuthToken:", token);
    console.log("PreBookingToken:", preBookingToken);

    const response = await connect.get(`${Fetch.PreBookingdetails}?PreBookingToken=${preBookingToken}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("error get Booking detail", error);
    throw error;
  }
};



export const PropeortyBookingConfirm = async (payload) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const formData = new FormData();
    formData.append("PreBookingToken", payload.PreBookingToken);
    formData.append("TotalRoomRate", payload.TotalRoomRate);
    formData.append("TotalExtraBedCharges", payload.TotalExtraBedCharges);
    formData.append("TotalPayment", payload.TotalPayment);
    formData.append("Tax", payload.Tax);
    formData.append("TotalAfterTax", payload.TotalAfterTax);
    formData.append("Discount", payload.Discount);
    formData.append("PaymentComment", payload.PaymentComment);
    formData.append("CompanyName", payload.CompanyName);
    formData.append("RegistrationNumber", payload.RegistrationNumber);
    formData.append("RegistrationCompanyName", payload.RegistrationCompanyName);
    formData.append("RegistrationCompanyAddress", payload.RegistrationCompanyAddress);
    formData.append("MarketSegment", payload.MarketSegment);
    formData.append("BookingComment", payload.BookingComment);
    formData.append("Title", payload.Title);
    formData.append("FirstName", payload.FirstName);
    formData.append("MiddleName", payload.MiddleName);
    formData.append("LastName", payload.LastName);
    formData.append("EmailAddress", payload.EmailAddress);
    formData.append("Address", payload.Address);
    formData.append("MobileNumber", payload.MobileNumber);
    formData.append("Country", payload.Country);
    formData.append("State", payload.State);
    formData.append("City", payload.City);
    formData.append("GuaranteeCodes", payload.GuaranteeCodes);
    formData.append("BusinessSource", payload.BusinessSource)

    const response = await connect.post(Fetch.SavePreBookingconfirm, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error("error save Pre Booking Confirm", error);
    throw error;
  }
};


// Property Meal Plan List
export const PropertyMealplan = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.PropertyMealPlanList,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  }
  catch (error) {
    console.log("error get Property Meal Plan form Api", error);
  }
}


// Property Save Meal Plan
export const AddMealPlan = async (MealPlanID, Code, Name, Description, IsActive) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('MealPlanID', MealPlanID);
    data.append('Code', Code);
    data.append('Name', Name);
    data.append('Description', Description);
    data.append('IsActive', IsActive);

    const response = await connect.post(Fetch.PropertyAddMealPlan, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data
  }
  catch (error) {
    console.log("error add meal plan in api", error);
  }
}


// Delete api of Meal plan
export const PropertyMealplanDelete = async (MealPlanID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.delete(`${Fetch.DeleteMealPlan}/${MealPlanID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("error deleting Meal Plan from API", error);
  }
};



// property rate code List
export const PropertyRateCode = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.PropertyRateCodeList,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  }
  catch (error) {
    console.log("error get Property Rate Code form Api", error);
  }
}


export const RateCodeTypes = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.RatecodeType,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  }
  catch (error) {
    console.log("error get  Rate Code type form Api", error);
  }
}

// Property Save Meal Plan
export const PropertySaveRatecode = async (RateCodeID, RateCodeTypeID, AccountID, Code, Name, Description, StartDate, EndDate) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('RateCodeID', RateCodeID);
    data.append('RateCodeTypeID', RateCodeTypeID);
    data.append('AccountID', AccountID);
    data.append('Code', Code);
    data.append('Name', Name);
    data.append('Description', Description);
    data.append('StartDate', StartDate);
    data.append('EndDate', EndDate);

    const response = await connect.post(Fetch.PropertyAddRateCode, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data
  }
  catch (error) {
    console.log("error add meal plan in api", error);
  }
}

// Delete api of Rate Code
export const PropertyRateCodeDelete = async (RateCodeID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.delete(`${Fetch.DeleterateCode}/${RateCodeID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("error deleting Meal Plan from API", error);
  }
};


// get mapping list from api
export const PropertyMAppingList = async (rateCodeId) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.MappingList}?rateCodeId=${rateCodeId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    );
    console.log("response", response)

    return response.data;

  } catch (error) {
    console.log("error get Mapping list from API", error);
    return [];
  }
};

// property mapping save
export const PropertySaveMapping = async (RateCodeMealPlanID, RateCodeID, MealPlanID, RoomTypeID, BaseRate, DoubleRate, TripleRate, ExtraBed, ExtraAdultRate, ExtraChildRate, EffectiveFrom, EffectiveTo, IsActive) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('RateCodeMealPlanID', RateCodeMealPlanID);
    data.append('RateCodeID', RateCodeID);
    data.append('MealPlanID', MealPlanID);
    data.append('RoomTypeID', RoomTypeID);
    data.append('BaseRate', BaseRate);
    data.append('DoubleRate', DoubleRate);
    data.append('TripleRate', TripleRate);
    data.append('ExtraBed', ExtraBed);
    data.append('ExtraAdultRate', ExtraAdultRate);
    data.append('ExtraChildRate', ExtraChildRate);
    data.append('EffectiveFrom', EffectiveFrom);
    data.append('EffectiveTo', EffectiveTo);
    data.append('IsActive', IsActive);


    const response = await connect.post(Fetch.SaveMapping, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error fetching Propoerty Booking Cancle", error);
  }
};

// Delete MApping
export const PropertyMappingDelete = async (RateCodeMealPlanID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.delete(`${Fetch.DeleteMapping}/${RateCodeMealPlanID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("error deleting Mapping from API", error);
  }
};


export const Propertybookings = async ({
  BookingDate = "",
  CompName = "",
  GuestName = "",
  CheckInDate = "",
  CheckOutDate = ""
}) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const url = `${Fetch.PropertyBookinglist}?BookingDate=${BookingDate}&CompName=${CompName}&GuestName=${GuestName}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}`;

    console.log("url", url); // For debugging

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("error get Booking list", error);
    return [];
  }
};

// edit boooking list 
export const Editbookings = async (id) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.EditBookingdetail}?ID=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error editing booking details", error);
  }
}


// Property generate pdf
export const Propertybookingpdf = async (BONRESID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.PropertyBookingVoucher}/${BONRESID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    // console.log("pdf data", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching Property Booking pdf", error);
    return [];
  }
};

// Booking Cancel Reason 
export const PropertyCancelReason = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BookingCancelReason, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Get Booking Cancel Reason", error);
  }
}

// cancle booking api
export const PropertyBookingCancle = async (BONRESID, PropertyID, Code, Description) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('BONRESID', BONRESID);
    data.append('PropertyID', PropertyID);
    data.append('Code', Code);
    data.append('Description', Description);


    const response = await connect.post(Fetch.BookingCancle, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("proprety Booking Cancle", response);
    return response.data;
  }
  catch (error) {
    console.log("error fetching Propoerty Booking Cancle", error);
  }
};


export const DeletePreBookingRoom = async (roomId, preBookingToken) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const formData = new FormData();
    formData.append("ID", roomId);
    formData.append("PreBookingToken", preBookingToken);

    const response = await connect.post(Fetch.DeleteRoomdetail, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting room:", error);
  }
};


// PMS details Find
export const PropertyPMSDetails = async (name, profileType) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.PMSDetailsFind, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      params: {
        Name: name,
        ProfileType: profileType,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching PMS Details:", error);
    throw error;
  }
};




// Agent get list and save data
export const getagentlist = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.Agentlist, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error get agent list", error);
  }
}


export const getAgentByID = async (id) => {
  const fullList = await getagentlist();
  return fullList?.find(agent => agent.AgentID === parseInt(id));
};



export const getAgentcontactList = async (LoginID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const url = `${Fetch.AgnetContactList}?AgentID=${LoginID}`;
    // console.log("Calling API:", url);
    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get agent contact list", error);
  }
}

export const SaveAgentdetail = async (agentData) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.Agentsavedetails, agentData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save agent detail", error);
  }
}


// corporat get and save details

export const getCorporatedetail = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.Corporatedetail, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error get corporate detail", error);
  }
}

export const getCorporateByID = async (id) => {
  const fullList = await getCorporatedetail();
  return fullList?.find(item => item.CorporateID === parseInt(id));
};


export const getCorporatecontactList = async (LoginID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const url = `${Fetch.CorporateContactlist}?CorporateID=${LoginID}`;

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    })
    return response.data;
  }
  catch (error) {
    console.log("error get Corporate contact list", error);
  }
}

export const Savecorporatedetail = async (data) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(Fetch.CorporateDetailSave, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save corporate detail", error);
  }
}

// BUlk room rates updates save api

export const SaveBulRoomRates = async (ConID, payload) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.post(`${Fetch.BulRoomRateUpdate}?ConID=${ConID}`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Bulk Room rates", error);
  }
}

// Get Property MArket Segment
export const PropertyMarketSegmentApi = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.MarSegmant, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Property Market Segment", error);
  }
}


// Save MArket segment
export const PropertySaveMarketsegment = async (formData) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('ID', formData.ID);
    data.append('Code', formData.Code);
    data.append('MarketSeg', formData.MarketSeg);

    const response = await connect.post(Fetch.SaveMArSegment, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save property market segment", error);
  }
}


// get Business Soource List
export const PropertyBusinessSourceList = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.BusinessSourList, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get property business source ", error);

  }
}

// save Property Business Source
export const SavePropertyBusinessSource = async (formdata) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('ID', formdata.ID);
    data.append('Code', formdata.Code);
    data.append('BusinessSource', formdata.BusinessSource);

    const response = await connect.post(Fetch.SaveBusinessSource, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save business source", error);
  }
}


export const PropertyGuaranteeCodes = async () => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(Fetch.GuaranteeCodes, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    console.log("data", response);
    return response.data;
  }
  catch (error) {
    console.log("error get property Guarantee Codes ", error);
  }
}

export const SavePropertyGuaranteeCodes = async (formdata) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    let data = new FormData();
    data.append('ID', formdata.ID);
    data.append('Code', formdata.Code);
    data.append('GuaranteeCodes', formdata.GuaranteeCodes);

    const response = await connect.post(Fetch.SaveGuaranteeCodes, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Guarantee Codes", error);
  }
}


export const PropertyReport = async (BookingDate, GuestName, CompName, CheckInDate, CheckOutDate) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.Report}?BookingDate=${BookingDate}&GuestName=${GuestName}&CompName=${CompName}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error get Report data", error);
  }
}


export const PropertyBookingReport = async (BookingDateFrom, BookingDateTo, CheckInDateFrom, CheckInDateTo, GuestName, AgentName, CompName, BusinessSource, MarketSegment, BookingStatus, PaymentStatus, ConfirmationNumber, BONRefNumber) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.BookingReport}?BookingDateFrom=${BookingDateFrom}&BookingDateTo=${BookingDateTo}&CheckInDateFrom=${CheckInDateFrom}&CheckInDateTo=${CheckInDateTo}&GuestName=${GuestName}&AgentName=${AgentName}&CompName=${CompName}&BusinessSource=${BusinessSource}&MarketSegment=${MarketSegment}&BookingStatus=${BookingStatus}&PaymentStatus=${PaymentStatus}&ConfirmationNumber=${ConfirmationNumber}&BONRefNumber=${BONRefNumber}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error get Booking Report data", error);
  }
}

export const PropertyBookingReportPDF = async (
  BookingDateFrom, BookingDateTo, CheckInDateFrom, CheckInDateTo,
  GuestName, AgentName, CompName, BusinessSource, MarketSegment,
  BookingStatus, PaymentStatus, ConfirmationNumber, BONRefNumber
) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(
      `${Fetch.BookingReportPDF}?BookingDateFrom=${BookingDateFrom}&BookingDateTo=${BookingDateTo}&CheckInDateFrom=${CheckInDateFrom}&CheckInDateTo=${CheckInDateTo}&GuestName=${GuestName}&AgentName=${AgentName}&CompName=${CompName}&BusinessSource=${BusinessSource}&MarketSegment=${MarketSegment}&BookingStatus=${BookingStatus}&PaymentStatus=${PaymentStatus}&ConfirmationNumber=${ConfirmationNumber}&BONRefNumber=${BONRefNumber}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        responseType: "blob" //
      }
    );

    return response;
  } catch (error) {
    console.log("error get Booking Report PDF", error);
  }
};



export const PropertyDynamicVoucher = async (id) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.DynamicVoucher}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error get Booking Voucher", error);
  }
}

export const PropertyVoucherSend = async (id, EmailID) => {
  try {
    const token = localStorage.getItem("PropertyAuthToken");

    const response = await connect.get(`${Fetch.VoucherSend}?id=${id}&EmailID=${EmailID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error send Booking voucher email", error);
  }
}


// Ragistration Start

export const ReservationLogin = async (Username, Password) => {
  try {

    let data = new FormData();
    data.append('Username', Username);
    data.append('Password', Password);

    const response = await connect.post(Fetch.ReservationLogin, data);
    return response.data;
  } catch (e) {
    console.log("error Fetch ReservationLogin", e.response?.data || e);
    return null;
  }
};

// user logout
export const Logoutuser = async () => {
  try {
    const Username = localStorage.getItem("ReservationUsername");
    const Password = localStorage.getItem("ReservationPassword");
    const token = localStorage.getItem("ReservationAuthToken");

    if (!Username || !Password || !token) {
      console.log("Missing logout credentials");
      return null;
    }

    let data = new FormData();
    data.append("Username", Username);
    data.append("Password", Password);
    data.append("AuthToken", token);

    const response = await connect.post(Fetch.LogOutUser, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.log("Error logging out user", error);
    return null;
  }
};

// reservation notification
export const GetNotification = async () => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(Fetch.Notification, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
    );

    return response.data;
  } catch (error) {
    console.log("error get notifications", error);
  }
};

export const ResDashboRoomInventory = async (startDate, endDate, PID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    console.log("pid", PID);
    const response = await connect.get(`${Fetch.ReservationRoomInventory}?StartDate=${startDate}&EndDate=${endDate}&PropID=${PID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error get reservation Dashboard Room inventory", error);
  }
}


export const ReservationPreBooking = async (propertyId, checkIn, checkOut, rateTypeCode, rateCodeID, totalRoom) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(Fetch.ReserPreBookingContinue, {
      headers: {
        Authorization: `Bearer ${token}`
      },
      params: {
        PropertyID: propertyId,
        CheckIn: checkIn,
        CheckOut: checkOut,
        RateTypeCode: rateTypeCode,
        RateCodeID: rateCodeID,
        TotalRoom: totalRoom,
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Get resevation Pre Booking Continue", error);
  }
}

export const getReserRoomRateSelect = async (rateCodeID, mealPlanID, roomTypeID, rateType, rateTypeID, PropertyID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const url = `${Fetch.ReserRoomRateSelect}?rateCodeID=${rateCodeID}&mealPlanID=${mealPlanID}&roomTypeID=${roomTypeID}&rateType=${rateType}&rateTypeID=${rateTypeID}&PropertyID=${PropertyID}`;

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    // console.log("API Response:", response.data);

    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Room rate select", error);
  }
}

export const AddRoomDetails = async (formData) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserBookingAddRoom, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      }
    });
    return response.data;
  }
  catch (error) {
    if (error.message === "Network Error" || !error.response) {
      return { Message: "Network error. Please check your internet connection." };
    }
    return error.response?.data || { Message: "Something went wrong" };
  }
}

export const ReserBookingDetail = async () => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const preBookingToken = localStorage.getItem("PreBookingToken");

    const response = await connect.get(`${Fetch.ReserPreBookingdetail}?PreBookingToken=${preBookingToken}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Pre Booking Room detail", error);
  }
}

export const ReserDeletePreBookingRoom = async (roomId, preBookingToken, PropertyID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const formData = new FormData();
    formData.append("ID", roomId);
    formData.append("PreBookingToken", preBookingToken);
    formData.append("PropertyID", PropertyID);

    const response = await connect.post(Fetch.ReserDeletePreRoom, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting reservation room:", error);
  }
};

export const ReserSaveBookingconfirm = async (payload) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const FormData = require("form-data");
    let data = new FormData();

    data.append("PreBookingToken", payload.PreBookingToken || "");
    data.append("TotalRoomRate", payload.TotalRoomRate || "");
    data.append("TotalExtraBedCharges", payload.TotalExtraBedCharges || "");
    data.append("TotalPayment", payload.TotalPayment || "");
    data.append("Tax", payload.Tax || "");
    data.append("TotalAfterTax", payload.TotalAfterTax || "");
    data.append("Discount", payload.Discount || "0");
    data.append("PaymentComment", payload.PaymentComment || "");
    data.append("CompanyName", payload.CompanyName || "");
    data.append("RegistrationNumber", payload.RegistrationNumber || "");
    data.append("RegistrationCompanyName", payload.RegistrationCompanyName || "");
    data.append("RegistrationCompanyAddress", payload.RegistrationCompanyAddress || "");
    data.append("MarketSegment", payload.MarketSegment || "");
    data.append("BusinessSource", payload.BusinessSource || "")
    data.append("BookingComment", payload.BookingComment || "");
    data.append("Title", payload.Title || "");
    data.append("FirstName", payload.FirstName || "");
    data.append("MiddleName", payload.MiddleName || "");
    data.append("LastName", payload.LastName || "");
    data.append("EmailAddress", payload.EmailAddress || "");
    data.append("Address", payload.Address || "");
    data.append("MobileNumber", payload.MobileNumber || "");
    data.append("Country", payload.Country || "");
    data.append("State", payload.State || "");
    data.append("City", payload.City || "");
    data.append("GuaranteeCodes", payload.GuaranteeCodes);
    data.append("PropertyID", payload.PropertyID || "");

    const response = await connect.post(Fetch.ReserPreBookingConfirm, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.log(" error save Pre Booking confirm", error);
    throw error;
  }
};


export const ReservationBookinglist = async ({ propertyID, BookingDate = "", GuestName = "", CompName = "", CheckInDate = "", CheckOutDate = "", }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBookingList}?PID=${propertyID}&BookingDate=${BookingDate}&GuestName=${GuestName}&CompName=${CompName}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Booking List", error);
    return [];
  }
};

export const ReserDynamicVoucher = async (id, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("id", id);
    // console.log("propid", PropID);

    const response = await connect.get(`${Fetch.RserDynamicVoucher}?id=${id}&PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error get Reservation Booking Voucher", error);
  }
}

export const ReserVoucherDetails = async (BONRESID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserBookingVouserDetails}/${BONRESID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Voucher detail", error);
    return [];
  }
};

export const ReserVoucherSend = async (id, EmailID, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserSendVoucher}?id=${id}&EmailID=${EmailID}&PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.log("error send Booking voucher email.", error);
  }
}

export const Reservationbookingpdf = async (BONRESID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.BookingPDF}/${BONRESID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Booking pdf", error);
    return [];
  }
};


// Booking Cancel Reason 
export const ReserCancelReason = async (PropertyID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserBookingCancleResion}?PropertyID=${PropertyID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Get reservation Booking Cancel Reason", error);
  }
}

// cancle booking api
export const ReserBookingCancle = async (BONRESID, PropertyID, Code, Description) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('BONRESID', BONRESID);
    data.append('PropertyID', PropertyID);
    data.append('Code', Code);
    data.append('Description', Description);


    const response = await connect.post(Fetch.ReserBookingCancled, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error reservation Booking Cancle", error);
  }
};

// reservation rate code list

export const ReservationRateCode = async () => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(Fetch.ReserRAteCodeList, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error get reservation rate code", error);
  }
}



//Property List
export const Property = async () => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(Fetch.PropertyList, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error fetch Property", error);
    return [];
  }
};


export const GetResAgentList = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");
    const response = await connect.get(`${Fetch.ReservationAgentList}?PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error get Reservation agent list", error);
  }
}

export const GetResAgentByID = async (id, PropID) => {
  const fullList = await GetResAgentList(PropID);
  return fullList?.find(agent => agent.AgentID === parseInt(id));
};

export const SaveResAgentdetail = async (agentData, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const url = `${Fetch.ReservationSaveAgent}?PropID=${PropID}`

    const response = await connect.post(url, agentData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation agent detail", error);
  }
}




export const GetResCorporatedetail = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");
    const response = await connect.get(`${Fetch.ReservationCorporateList}?PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error get Reservation corporate detail", error);
  }
}

export const GetResCorporateByID = async (id, PropID) => {
  const fullList = await GetResCorporatedetail(PropID);
  return fullList?.find(item => item.CorporateID === parseInt(id));
};

export const GetCorporateByID = async (id, propID) => {
  if (!propID) {
    console.warn("getCorporateByID called without propID");
  }
  return await GetResCorporateByID(id, propID);
};


export const SaveResCorporateDetail = async (data, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");
    const url = `${Fetch.ReservationSaveCorporate}?PropID=${PropID}`

    const response = await connect.post(url, data, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation corporate detail", error);
  }
}

export const ReservationRateCodeList = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationRateCodeList}?PropID=${PropID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Rate Code form Api", error);
  }
}

export const ReserSaveRatecode = async (PropID, RateCodeID, RateCodeTypeID, AccountID, Code, Name, Description, StartDate, EndDate) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('PropID', PropID);
    data.append('RateCodeID', RateCodeID);
    data.append('RateCodeTypeID', RateCodeTypeID);
    data.append('AccountID', AccountID);
    data.append('Code', Code);
    data.append('Name', Name);
    data.append('Description', Description);
    data.append('StartDate', StartDate);
    data.append('EndDate', EndDate);

    const response = await connect.post(Fetch.ReservationSaveRateCode, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data
  }
  catch (error) {
    console.log("error add Reservation rate code in api", error);
  }
}


export const ReserRateCodeDelete = async (RateCodeID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.delete(`${Fetch.ResvationDeleteRateCode}/${RateCodeID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.log("error deleting Reservation Rate code from API", error);
  }
};


export const ReservationMealplan = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationMealPlan}?PropID=${PropID}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Meal Plan form Api", error);
  }
}


export const ReserAddMealPlan = async (PropID, MealPlanID, Code, Name, Description, IsActive) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('PropID', PropID);
    data.append('MealPlanID', MealPlanID);
    data.append('Code', Code);
    data.append('Name', Name);
    data.append('Description', Description);
    data.append('IsActive', IsActive);

    const response = await connect.post(Fetch.ReservationSaveMealPlan, data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    return response.data
  }
  catch (error) {
    console.log("error Reservation add meal plan in api", error);
  }
}


export const ResRoomlist = async (PropertyID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationRoomDetail}?PropertyID=${PropertyID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    console.log("api data form back end", response)
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation room list", error);
  }
}


export const ReservationMAppingList = async (rateCodeId, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationMappingList}?rateCodeId=${rateCodeId}&PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
    );
    return response.data;

  } catch (error) {
    console.log("error get Reservation Mapping list from API", error);
    return [];
  }
};


export const ReservationSaveMapping = async (PropID, RateCodeMealPlanID, RateCodeID, MealPlanID, RoomTypeID, BaseRate, DoubleRate, TripleRate, ExtraBed, ExtraAdultRate, ExtraChildRate, EffectiveFrom, EffectiveTo, IsActive) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('PropID', PropID);
    data.append('RateCodeMealPlanID', RateCodeMealPlanID);
    data.append('RateCodeID', RateCodeID);
    data.append('MealPlanID', MealPlanID);
    data.append('RoomTypeID', RoomTypeID);
    data.append('BaseRate', BaseRate);
    data.append('DoubleRate', DoubleRate);
    data.append('TripleRate', TripleRate);
    data.append('ExtraBed', ExtraBed);
    data.append('ExtraAdultRate', ExtraAdultRate);
    data.append('ExtraChildRate', ExtraChildRate);
    data.append('EffectiveFrom', EffectiveFrom);
    data.append('EffectiveTo', EffectiveTo);
    data.append('IsActive', IsActive);


    const response = await connect.post(Fetch.ReservationSaveMapping, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error save reservation mapping", error);
  }
};

export const ReservationMarketSegmentApi = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationMarketSegment}?PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Market Segment", error);
  }
}

export const ReserSaveMarketsegment = async (formData) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('PropID', formData.PropID);
    data.append('ID', formData.ID);
    data.append('Code', formData.Code);
    data.append('MarketSeg', formData.MarketSeg);


    const response = await connect.post(Fetch.ReservationSaveMarkSegment, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation market segment", error);
  }
}




export const ReserBusinessSource = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationBusinessSource}?PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation business source ", error);
  }
}

export const SaveReserBusinessSource = async (formdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('ID', formdata.ID);
    data.append('Code', formdata.Code);
    data.append('BusinessSource', formdata.BusinessSource);
    data.append('PropID', formdata.PropID);

    const response = await connect.post(Fetch.ReservationSaveBusinessSource, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation business source", error);
  }
}

export const ReservationBusinessSourceReport = async ({ PID = "", CheckInDate = "", CheckOutDate = "", BookingFrom = "", BookingTo = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBusinessSourceReport}?PID=${PID}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}&BookingFrom=${BookingFrom}&BookingTo=${BookingTo}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Booking List", error);
    return [];
  }
};

export const ReservationBusinessMonthlyRepport = async ({ PID = "", Year = "", Month = "", Code = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBusinessMonthlyReport}?PID=${PID}&Year=${Year}&Month=${Month}&Code=${Code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Business monthly Report ", error);
    return [];
  }
};

export const ReservationBusinessPropertyMonthlyRepport = async ({ PID = "", Year = "", Month = "", Code = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBusinessPropertyMonthlyReport}?PID=${PID}&Year=${Year}&Month=${Month}&Code=${Code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Business Property monthly Report ", error);
    return [];
  }
};


export const ReservationBusinessYearlyRepport = async ({ PID = "", Year = "", Code = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBusinessYearlyReport}?PID=${PID}&Year=${Year}&Code=${Code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Business Yearly Report ", error);
    return [];
  }
};

export const ReservationBusinessPropertyYearlyRepport = async ({ PID = "", Year = "", Code = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserBusinessPropertyYearlyReport}?PID=${PID}&Year=${Year}&Code=${Code}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Business Property Yearly Report ", error);
    return [];
  }
};



export const ReservationMarketsegmentReport = async ({ PID = "", CheckInDate = "", CheckOutDate = "", BookingFrom = "", BookingTo = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // console.log("propertyid", propertyID)
    const response = await connect.get(`${Fetch.ReserMarketSegmentReport}?PID=${PID}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}&BookingFrom=${BookingFrom}&BookingTo=${BookingTo}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching Reservation Reser Market SegmentReport", error);
    return [];
  }
};


export const ReservationAgentProduReport = async ({ PID = "", CheckInDate = "", CheckOutDate = "", BookingFrom = "", BookingTo = "", AgentName = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");
    const url = `${Fetch.ReserAgentproduReport}?PID=${PID}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}&BookingFrom=${BookingFrom}&BookingTo=${BookingTo}&AgentName=${AgentName}`
    console.log("url", url)
    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("Agent report response", response)
    return response.data;
  } catch (error) {
    console.log("Error fetching Reser Aget Productivity List", error);
    return [];
  }
};


export const ReservationCompanyProduReport = async ({ PID = "", CheckInDate = "", CheckOutDate = "", BookingFrom = "", BookingTo = "", CompanyName = "" }) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");
    const url = `${Fetch.ReserCompanyproduReport}?PID=${PID}&CheckInDate=${CheckInDate}&CheckOutDate=${CheckOutDate}&BookingFrom=${BookingFrom}&BookingTo=${BookingTo}&CompanyName=${CompanyName}`
    console.log("url", url)
    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    console.log("Company report response", response)

    return response.data;
  } catch (error) {
    console.log("Error fetching Reser Company Productivity List", error);
    return [];
  }
};

// export const ReservationPMSDetails = async (name, profileType, PropID) => {
//   try {
//     const token = localStorage.getItem("ReservationAuthToken");

//     const response = await connect.get(Fetch.ReservationPMSDetail, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//         "Content-Type": "application/json"
//       },
//       params: {
//         Name: name,
//         ProfileType: profileType,
//         PropID: PropID,
//       },

//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching Reservation PMS Details:", error);
//     throw error;
//   }
// };

export const ReservationPMSDetails = async (name, profileType, PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    // Console karne ke liye
    const params = {
      Name: name,
      ProfileType: profileType,
      PropID: PropID,
    };
    console.log("Sending params:", params);

    const response = await connect.get(Fetch.ReservationPMSDetail, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      params: params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching Reservation PMS Details:", error);
    throw error;
  }
};


export const ReserGuaranteeCodes = async (PropID) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReservationGuaranteeCode}?PropID=${PropID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Guarantee Codes ", error);
  }
}

export const SaveReserGuaranteeCodes = async (formdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    let data = new FormData();
    data.append('ID', formdata.ID);
    data.append('Code', formdata.Code);
    data.append('GuaranteeCodes', formdata.GuaranteeCodes);
    data.append('PropID', formdata.PropID);

    const response = await connect.post(Fetch.ReservationSaveGuaranteeCodes, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation Guarantee Codes", error);
  }
}



export const ReserVoucherTermsAndCondi = async (propertyId) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserVoucherTermsAndCondition}?propertyId=${propertyId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Voucher Terms And Condition ", error);
  }
}

export const SaveReserTermAndCon = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserAddTermsAndCon, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation Terms And Condition", error);
  }
}

export const DeleteReserTermAndCon = async (id) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.delete(`${Fetch.ReserDeleteTermsAndCon}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Delete Reservation Terms And Condition", error);
  }
}


export const EditReserTermAndCon = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserUpdateTermsAndCon, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Edit Reservation Terms And Condition", error);
  }
}


export const ReserVoucherConnectivity = async (propertyId) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserVoucherConnectivity}?propertyId=${propertyId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Voucher Connectivity ", error);
  }
}





export const SaveReserConnectivity = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserAddConnectivity, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation Connectivity", error);
  }
}


export const DeleteReserConnectivity = async (id) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.delete(`${Fetch.ReserDeleteConnectivity}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Delete Reservation Connectivity", error);
  }
}


export const EditReserConnectivity = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserUpdateConnectivity, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Edit Reservation Connectivity", error);
  }
}

export const ReserVoucherOffers = async (propertyId) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.get(`${Fetch.ReserVoucherOffers}?propertyId=${propertyId}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error get Reservation Voucher Offers", error);
  }
}


export const SaveReserVoucherOffer = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserAddVoucherOffers, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error save Reservation Voucher Offer", error);
  }
}


export const DeleteReserVoucherOffer = async (id) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.delete(`${Fetch.ReserDeleteVoucherOffers}?id=${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Delete Reservation Voucher Offer", error);
  }
}


export const EditReserVoucherOffer = async (postdata) => {
  try {
    const token = localStorage.getItem("ReservationAuthToken");

    const response = await connect.post(Fetch.ReserUpdateVoucherOffers, postdata, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Edit Reservation Voucher Offer", error);
  }
}


// Agent Part Start

export const agentLoginService = async (Username, Password) => {
  try {
    let data = new FormData();
    data.append('Username', Username);
    data.append('Password', Password);

    const response = await connect.post(Fetch.Agentloginapi, data);
    // console.log("agent", response)
    return response.data;
  }
  catch (error) {
    console.log("error fatch aget logi api", error);
  }

};


// user logout
export const AgentLogoutuser = async () => {

  try {
    const Username = localStorage.getItem("AgentUsername");
    const Password = localStorage.getItem("AgentPassword");
    const token = localStorage.getItem("AgentAuthToken");

    if (!Username || !Password || !token) {
      console.log("Missing logout credentials");
      return null;
    }

    let data = new FormData();
    data.append("Username", Username);
    data.append("Password", Password);
    data.append("AuthToken", token);

    const response = await connect.post(Fetch.LogOutUser, data, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.log("Error logging out user", error);
    return null;
  }
};


export const agentPropertylist = async () => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(Fetch.AgentProplist, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  } catch (error) {
    console.log("Error fetching agent property list:", error.response?.data || error.message);
    return [];
  }
};


// aget Room add

export const SaveAgentPreBookingRoomAdd = async (formData) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.post(Fetch.AgentAddRoomWeb, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      }
    });
    return response.data;
  }
  catch (error) {
    return error.response?.data || { Message: "Something went wrong" };
  }
}



export const agentroomlist = async (PropertyID) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(`${Fetch.AgentRoomlist}?PropertyID=${PropertyID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    return response.data;
  }
  catch (error) {
    console.log("error fetch agent room list", error);
  }
};

export const getRoomListByPropertyID = async (PropertyID) => {
  const token = localStorage.getItem("AgentAuthToken");
  const response = await connect.get(`/API/AgentMobileAPI/PropertyRoomList?PropertyID=${PropertyID}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return response.data;
};


export const agentPreBooking = async ({ PropertyID, CheckIn, CheckOut, TotalRoom }) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const url = `${Fetch.AgentWebPreBookingContinue}?PID=${PropertyID}&CheckIn=${CheckIn}&CheckOut=${CheckOut}&TotalRoom=${TotalRoom}`;

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log(" Error fetching PreBooking:", error.response?.data || error);
    return null;
  }
};



export const agentsaveGuestdetail = async (guestData) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const formData = new FormData();
    for (let key in guestData) {
      formData.append(key, guestData[key]);
    }

    const response = await connect.post(
      Fetch.AgentPrebookingGuentdetails,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        },
      }
    );

    return response.data;
  } catch (error) {
    console.log("error fetch save guest", error);
    return null;
  }
};



export const agentsaveCompanydetail = async (Companydata) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");
    // console.log("TOKEN:", localStorage.getItem("AgentAuthToken"));

    const formData = new FormData();
    for (let key in Companydata) {
      formData.append(key, Companydata[key]);
    }

    const response = await connect.post(Fetch.AgentPrebookingCompanydetails, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error fetch save Company", error)
  }
}


export const agentsaveComment = async (BookingCommentdata) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");
    // console.log("TOKEN:", localStorage.getItem("AgentAuthToken"));

    const formData = new FormData();
    for (let key in BookingCommentdata) {
      formData.append(key, BookingCommentdata[key]);
    }

    const response = await connect.post(Fetch.AgentPrebookingComment, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    console.log("error fetch save Comment", error)
  }
}


export const agentGuestdetail = async ({ PreBookingToken }) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");
    const url = `${Fetch.AgentGuestDetail}?PreBookingToken=${PreBookingToken}`;

    // console.log("Final API URL:", url);

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.log("error fetch agent guest detail", error);
  }
};



export const agentPrebookingconfirmsave = async (ConfirmdataToSend) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const formData = new FormData();
    formData.append("PreBookingToken", ConfirmdataToSend.PreBookingToken);
    formData.append("TotalAfterTax", ConfirmdataToSend.TotalAfterTax);

    // console.log("api url", Fetch.AgentPrebookingConfirm);
    // console.log("ConfirmdataToSend", ConfirmdataToSend);

    const response = await connect.post(Fetch.AgentPrebookingConfirm, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("response", response);

    return response.data;
  }
  catch (error) {
    console.log("error fetch booking Confirm", error);
  }
}

export const getagentBookingList = async (PID) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const url = `${Fetch.AgentBookinglist}?PID=${PID}`;

    const response = await connect.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("list data", response);
    return response.data;
  }
  catch (error) {
    console.log("error get agent booking list", error);
  }
}


export const AgentVoucher = async (BONRESID) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(`${Fetch.AgentBookingVoucher}/${BONRESID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("agentpdfdata", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching Agent Booking pdf", error);
    return [];
  }
};

// Ahent notification
export const GetAgentNotify = async () => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(Fetch.Notification, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
    );

    return response.data;
  } catch (error) {
    console.log("error get notifications", error);
  }
};



// agent booking details

export const GetAgentPreBookingRoomdetail = async () => {
  try {
    const token = localStorage.getItem("AgentAuthToken");
    const preBookingToken = localStorage.getItem("AgentPreBookingToken");

    // console.log("PropertyAuthToken:", token);
    console.log("AgentPreBookingToken:", preBookingToken);

    const response = await connect.get(`${Fetch.AgentBookingDetails}?PreBookingToken=${preBookingToken}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    console.log("detail data", response);
    return response.data;
  } catch (error) {
    console.log("error get Booking detail", error);
    throw error;
  }
};

export const AgentDeletePreBookingRoom = async (roomId, preBookingToken) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const formData = new FormData();
    formData.append("ID", roomId);
    formData.append("PreBookingToken", preBookingToken);

    const response = await connect.post(Fetch.AgentRoomDelete, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "multipart/form-data",
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting room:", error);
  }
};


export const AgentPropeortyBookingConfirm = async (payload) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const formData = new FormData();
    formData.append("PreBookingToken", payload.PreBookingToken);
    formData.append("TotalRoomRate", payload.TotalRoomRate);
    formData.append("TotalExtraBedCharges", payload.TotalExtraBedCharges);
    formData.append("TotalPayment", payload.TotalPayment);
    formData.append("Tax", payload.Tax);
    formData.append("TotalAfterTax", payload.TotalAfterTax);
    formData.append("Discount", payload.Discount);
    formData.append("PaymentComment", payload.PaymentComment);
    formData.append("CompanyName", payload.CompanyName);
    formData.append("RegistrationNumber", payload.RegistrationNumber);
    formData.append("RegistrationCompanyName", payload.RegistrationCompanyName);
    formData.append("RegistrationCompanyAddress", payload.RegistrationCompanyAddress);
    formData.append("MarketSegment", payload.MarketSegment);
    formData.append("BookingComment", payload.BookingComment);
    formData.append("Title", payload.Title);
    formData.append("FirstName", payload.FirstName);
    formData.append("MiddleName", payload.MiddleName);
    formData.append("LastName", payload.LastName);
    formData.append("EmailAddress", payload.EmailAddress);
    formData.append("Address", payload.Address);
    formData.append("MobileNumber", payload.MobileNumber);
    formData.append("Country", payload.Country);
    formData.append("State", payload.State);
    formData.append("City", payload.City);
    formData.append("PropertyID", payload.PropertyID);

    const response = await connect.post(Fetch.AgentConfirmBooking, formData, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error("error save Pre Booking Confirm", error);
    throw error;
  }
};

// Booking Cancel Reason 
export const AgentCancelReason = async (PropertyID) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(`${Fetch.AgentBookingCancelReason}?PropertyID=${PropertyID}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
    return response.data;
  }
  catch (error) {
    console.log("error Get Booking Cancel Reason", error);
  }
}


// cancle booking api
export const AgentBookingCancle = async (BONRESID, PropertyID, Code, Description) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    let data = new FormData();
    data.append('BONRESID', BONRESID);
    data.append('PropertyID', PropertyID);
    data.append('Code', Code);
    data.append('Description', Description);


    const response = await connect.post(Fetch.AgentBookingCancle, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("proprety Booking Cancle", response);
    return response.data;
  }
  catch (error) {
    console.log("error fetching Propoerty Booking Cancle", error);
  }
};


export const Agentbookingpdf = async (BONRESID) => {
  try {
    const token = localStorage.getItem("AgentAuthToken");

    const response = await connect.get(`${Fetch.AgentBookingWebVoucher}/${BONRESID}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    console.log("pdf data", response);
    return response.data;
  } catch (error) {
    console.log("Error fetching Property Booking pdf", error);
    return [];
  }
};

